import createReactContext from '@ant-design/create-react-context';
const FormContext = createReactContext({
    labelAlign: 'right',
    vertical: false,
});
export default FormContext;
